import React from "react";
import { MdArrowDropDownCircle } from "react-icons/md";
import { Link } from "react-router-dom";
import moment from "moment";
import classNames from "classnames";

const MembershipCard = ({ membership }) => {
  const {
    _id,
    name,
    startDate,
    endDate,
    units,
    billingInfo,
    additionalServices,
    isDeleted,
    type,
    terminationDate,
  } = membership;

  let isCompleted = new Date(endDate).getTime() < new Date().getTime();
  let isValid = isDeleted === true || isCompleted === true;

  const renderDate = () => {
    if (terminationDate && isDeleted) {
      return `Terminated on ${moment(terminationDate).format("ll")}`;
    }

    if (isCompleted) {
      return `Completed on ${moment(endDate).format("ll")}`;
    }

    return (
      moment(startDate).format("ll") + " - " + moment(endDate).format("ll")
    );
  };

  return (
    <div
      className={classNames({
        "p-6 rounded border border-gray-400 flex-shrink-0": true,
        "bg-white shadow-md": !isDeleted && !isCompleted,
        // "bg-red-400": isValid,
      })}
    >
      {/* <div className="flex flex-col justify-between bg-red-500"> */}
      <div className="flex-1">
        <div>
          <p className="bg-gray font-bold text-xs leading-3 tracking-widest uppercase">
            {renderDate()}
          </p>
        </div>
        <div className="my-2">
          <h2 className="font-medium text-2xl leading-7">{name}</h2>
        </div>
        <div className="mb-1">
          <p className="text-xs leading-3">{type}</p>
        </div>
        <div>
          <p className="text-xs leading-3">{units} Units</p>
        </div>
      </div>
      {/*  */}
      <div className="lg:flex mt-10 justify-between items-center align-baseline">
        <div>
          <div className="lg:inline">
            <span className="text-base font-bold leading-5">SPOC :</span>
            <span>{billingInfo?.name}</span>
          </div>
          <div className="lg:inline lg:mx-8 lg:my-0 my-2">
            <span className="text-base font-bold leading-5">
              {additionalServices.length || 0}
            </span>
            <span> additional services</span>
          </div>
        </div>
        {/* Action Button */}
        {!isDeleted && !isCompleted && (
          <div className="flex flex-row-reverse">
            <Link
              to={`/update-membership/${_id}`}
              className="flex items-center justify-between outline-none"
            >
              <span className="uppercase text-base font-bold mr-2">edit</span>
              <MdArrowDropDownCircle size={16} />
            </Link>
          </div>
        )}
      </div>
      {/* </div> */}
    </div>
  );
};

export default MembershipCard;
